import DOMPurify from "dompurify";

// Centralizes the allowlist used everywhere stored HTML (e.g. ReactQuill-authored alert
// descriptions) is rendered via dangerouslySetInnerHTML, so a stored <script>/onerror=/
// javascript: payload can't execute in another user's browser (stored XSS).
export const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html ?? "", {
    ALLOWED_TAGS: ["b", "i", "em", "strong", "u", "s", "a", "p", "br", "ul", "ol", "li", "span", "div", "h1", "h2", "h3", "blockquote", "pre", "code"],
    ALLOWED_ATTR: ["href", "target", "rel", "class"],
  });
